import { getObjectUtil } from 'packages/src'
import { getValueReduxUtil } from '../../utils/get-value'

function getByIdPropReduxSelector (domainDataPath, propKeyPath = 'id', valueKeyPath) {
  return (state, props) => {
    const instance = getObjectUtil(state, `${domainDataPath}.${getObjectUtil(props, propKeyPath)}`)
    if (!valueKeyPath) {
      return instance
    }
    return getValueReduxUtil(instance, valueKeyPath)
  }
}

export default getByIdPropReduxSelector
